define('modules/editor/views/property_boxes/button_style',['require','exports','module','./base','../../services/image_upload/index','ldsh!../../templates/property_boxes/button_style'],function(require,exports,module){
  "use strict";
  var BasePB = require("./base"),
      ImageService = require("../../services/image_upload/index");

  module.exports = BasePB.extend({
    template: require("ldsh!../../templates/property_boxes/button_style"),
    myEvents: {
      "change .js-range": "onRangeChange",
      "change .js-bg-type": "changeBackgroundType",
      "click .js-image": "getImage",
      "click .js-remove-image": "removeImage",
      "click .js-tab-selector": "changeTab"
    },
    initialize: function(){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,arguments);
    },
    helpers: function(){
      return {
        "up_imageUrl": this.model.get("up-imageUrl"),
        "over_imageUrl": this.model.get("over-imageUrl"),
        "down_imageUrl": this.model.get("down-imageUrl")
      };
    },
    onRangeChange: function(e){
      var $range = $(e.currentTarget),
          $valueDisplay = this.$("#" + $range.data("display"));

      $valueDisplay.html($range.val());
      this._getPropertyValues();
    },
    changeBackgroundType: function(e){
      var $select = this.$(e.currentTarget),
          $form = $select.closest("form"),
          $secondColor = $form.find(".js-second-color"),
          $colorOpacity = $form.find(".js-color-opacity"),
          $imagePanel= $form.find(".js-image-panel"),
          bgType = $select.val();

      $secondColor.toggle(bgType === "gradient");
      $colorOpacity.toggle(bgType === "gradient");
      $imagePanel.toggle(bgType === "image");
    },
    getImage: function(e){
      e.preventDefault();
      var $button = this.$(e.currentTarget),
          state = $button.data("state");
      ImageService.loadImage(this.model.get(state + "-imageUrl"), _.bind(this.onImageLoaded, this, state));
    },
    removeImage: function(e){
      e.preventDefault();
      var state = this.$(e.currentTarget).data("state");
      this.model.set(state + "-imageUrl", null);
    },
    onImageLoaded: function(state, result){
      this.model.set(state + "-imageUrl", result.url);
    },
    changeTab: function(e){
      var $element = this.$(e.currentTarget),
          state = $element.data("state");

      e.preventDefault();
      //tab headers
      this.$(".js-tab-selector").removeClass("active");
      $element.addClass("active");
      //tab content
      this.$(".form-inner-tab").removeClass("active");
      this.$(".js-" + state + "-tab").addClass("active");
    },

    onRender: function (){
      this.$("#up-opacity-view").html(this.model.get("up-opacity"));
      this.$("#over-opacity-view").html(this.model.get("over-opacity"));
      this.$("#down-opacity-view").html(this.model.get("down-opacity"));

      this.$(".js-up-tab .js-color-opacity").toggle(this.model.get("up-backgroundType") === "gradient");
      this.$(".js-over-tab .js-color-opacity").toggle(this.model.get("over-backgroundType") === "gradient");
      this.$(".js-down-tab .js-color-opacity").toggle(this.model.get("down-backgroundType") === "gradient");

      this.$(".js-up-tab .js-second-color").toggle(this.model.get("up-backgroundType") === "gradient");
      this.$(".js-over-tab .js-second-color").toggle(this.model.get("over-backgroundType") === "gradient");
      this.$(".js-down-tab .js-second-color").toggle(this.model.get("down-backgroundType") === "gradient");

      this.$(".js-up-tab .js-image-panel").toggle(this.model.get("up-backgroundType") === "image");
      this.$(".js-over-tab .js-image-panel").toggle(this.model.get("over-backgroundType") === "image");
      this.$(".js-down-tab .js-image-panel").toggle(this.model.get("down-backgroundType") === "image");
    }
  });
});

